export enum DatesFormat {
  dateFormatPrimary = "dd/MM/y",
  timeFormatPrimary = "H:mm",
  yearFormat = "y",
  dateTimeFormatPrimary = "dd/MM/y H:mm",
  dayMonthYearFormat = "d MMMM yyyy",
  mothYearFormat = "MMM yyyy",
}
